export interface UploadObservation {
  startedAt: number;
  finishedAt: number;
  bytes: number;
  delivered: boolean;
}
/** Recent queue-to-receipt evidence, aggregated across the sender's connections. */
export class UploadCapacityWindow {
  private readonly samples: UploadObservation[] = [];
  record(sample: UploadObservation): void {
    if (!Number.isFinite(sample.startedAt) || !Number.isFinite(sample.finishedAt) ||
        sample.finishedAt <= sample.startedAt || !Number.isSafeInteger(sample.bytes) || sample.bytes < 0) return;
    this.samples.push({...sample});
    if (this.samples.length > 512) this.samples.shift();
  }
  snapshot(now = Date.now()): {confirmedRate: number; confirmedDeliveries: number; deadlineSuccess: number} {
    const samples = this.samples.filter(s => s.finishedAt > now - 10_000 && s.finishedAt <= now);
    this.samples.splice(0, this.samples.length, ...samples);
    const intervals = samples.map(s => [s.startedAt, s.finishedAt] as const).sort((a,b) => a[0] - b[0]);
    let duration = 0, end = -Infinity;
    for (const [start, finish] of intervals) { duration += Math.max(0, finish - Math.max(start, end)); end = Math.max(end, finish); }
    const confirmed = samples.filter(s => s.delivered);
    return {confirmedRate: duration ? confirmed.reduce((n,s) => n + s.bytes, 0) * 1000 / duration : 0,
      confirmedDeliveries: confirmed.length, deadlineSuccess: samples.length ? confirmed.length / samples.length : 1};
  }
}
